import axios from 'axios';
import ProgressBar from 'progressbar.js';

const onRequest = (config) => {
  // console.info(`[request] [${JSON.stringify(config)}]`);
  return config;
};

const onRequestError = (error) => {
  // console.error(`[request error] [${JSON.stringify(error)}]`);
  return Promise.reject(error);
};

const onResponse = (config) => {
  // console.info(`[request] [${JSON.stringify(config)}]`);
  return config;
};

const onResponseError = (error) => {
  // console.error(`[request error] [${JSON.stringify(error)}]`);
  return Promise.reject(error);
};

const createRequest = (props) => ({
  uri: props?.uri ?? `/api/sooper/flow/test`,
  method: props?.method ?? 'POST',
  headers: props?.headers ?? {
    'Content-Type': 'application/json',
  },
  payload: props?.payload ?? false,
  interceptors: {
    onRequest: props?.interceptors?.onRequest ?? onRequest,
    onRequestError: props?.interceptors?.onRequestError ?? onRequestError,
    onResponse: props?.interceptors?.onResponse ?? onResponse,
    onResponseError: props?.interceptors?.onResponseError ?? onResponseError,
  },
});

const exec = async (props) => {
  const httpAxios = axios.create(),
    requestProps = {
      url: `${props.uri}`,
      method: props?.method || 'GET',
      timeout: 1e5,
      headers: props?.headers,
      validateStatus: (status) => !!status,
    };

  if (requestProps.method === 'GET' && props?.payload) {
    Object.assign(requestProps, { params: props.payload });
  }

  if (['POST', 'PUT'].includes(requestProps.method) && props?.payload) {
    Object.assign(requestProps, { data: props.payload });
  }

  if (props?.interceptors) {
    const { onRequest, onRequestError, onResponse, onResponseError } =
      props.interceptors;
    httpAxios.interceptors.request.use(onRequest, onRequestError);
    httpAxios.interceptors.response.use(onResponse, onResponseError);
  }

  try {
    const { data } = await httpAxios.request(
      { ...requestProps },
      {
        transformRequest: [
          function (data, headers) {
            return JSON.stringify(data);
          },
        ],
        transformResponse: [
          function (data) {
            return JSON.parse(data);
          },
        ],
      },
    );
    return data;
  } catch (e) {
    console.log(e);
  }
};

const progressGradient = `<defs>
        <linearGradient id="gradient" gradientTransform="rotate(90)" gradientUnits="userSpaceOnUse">
            <stop offset="5%" stop-color="#004D07" />
            <stop offset="95%" stop-color="#00494D" />
        </linearGradient></defs>`;

const updateTemplateAttributes = (text, props) => {
  const matches = text.matchAll(/\[(.*?)\]/g);

  for (let match of matches) {
    if (match.length <= 1) {
      continue;
    }

    let [replace, key] = match;

    if (!props[key]) {
      continue;
    }

    text = text.replace(replace, props[key]);
  }

  return text;
};

const validateTasks = (stack) => {
  const isComplete = !stack.filter((e) => e.status === false).length;

  if (isComplete) {
    return setTimeout(() => {
      let params = new URLSearchParams(window.location.search);
      params.set('detour', true);
      return (window.location = `/full.php?${params}`);
    }, 1500);
  }

  setTimeout(() => {
    validateTasks(stack);
  }, 500);
};

export default class Detour {
  constructor(payload) {
    const container = document.getElementById('loading-sphere'),
      version =
        container.hasAttribute('version') &&
        container.getAttribute('version') === '2'
          ? +container.getAttribute('version')
          : 1,
      sphere = this.createLoaderSphere({ container, version });

    sphere.animate(0.3);
    sphere.svg.insertAdjacentHTML('afterbegin', progressGradient);
    Object.assign(this, { container, version, sphere, payload, tasks: {} });
  }

  stopAnimations() {
    if (typeof glimmer === 'number') {
      clearInterval(glimmer);
    }

    if (typeof tickComplete === 'function') {
      tickComplete();
    }

    if (typeof tickObj === 'object') {
      tickObj.stop();
    }
    // console.log(typeof tickObj);
    // if (typeof tickObj) {
    //   tickObj.stop();
    // }
  }

  async process(tasks) {
    // setTimeout(() => {
    //   if (typeof trustedFormStopRecording === 'function') {
    //     trustedFormStopRecording();
    //   }
    // }, 200);
    // this.sphere.animate(0.3);
    this.stopAnimations();

    for (let props of tasks) {
      let { name, ...task } = props,
        request = {
          uri: task?.endpoint,
          payload: task?.payload ?? this?.payload,
        };

      this.tasks[name] = { status: false, ...task };

      // if (task?.callback) {
      Object.assign(request, {
        interceptors: {
          onResponse: (config) => {
            if (task?.callback) {
              task.callback(config?.data?.payload);
            }
            this.tasks[name].status = true;
            // this.sphere.animate(animate);
            return config;
          },
          onRequestError: async (error) => {
            await exec(
              createRequest({
                uri: '/api/sooper/log/event/stfu',
                payload: {
                  task: name,
                  error: error?.message,
                  error_type: 'RequestError',
                  request_payload: request.payload,
                  request_endpoint: request.endpoint,
                  visit_id: window.sooper_panel.props.visit_id,
                },
              }),
            );
            return Promise.reject(error);
          },
          onResponseError: async (error) => {
            await exec(
              createRequest({
                uri: '/api/sooper/log/event/stfu',
                payload: {
                  task: name,
                  error: error?.message,
                  error_type: 'ResponseError',
                  request_payload: request.payload,
                  request_endpoint: request.endpoint,
                  visit_id: window.sooper_panel.props.visit_id,
                },
              }),
            );
            return Promise.reject(error);
          },
        },
      });
      // }

      await exec(createRequest(request));
    }
  }

  createLoaderSphere({ container, version }) {
    const props = {},
      self = this;

    if (version === 2) {
      let markers = new Map(),
        intervals = '100, 75, 50, 0'.split(', '),
        length = intervals.length - 1;

      intervals.map((m, i) => {
        markers.set(+m, i);
      });

      const span = document.createElement('span');
      span.setAttribute('id', 'countdown');
      span.setAttribute('current', length);
      span.innerText = length;
      container.append(span);

      Object.assign(props, {
        span,
        length,
        markers,
      });
    }

    return new ProgressBar.Circle(container, {
      strokeWidth:
        document.body.getAttribute('data-view-device-type') === 'mobile'
          ? 10
          : 13,
      easing: 'easeInOut',
      color: 'url(#gradient)',
      duration: 1500,
      trailColor: 'transparent',
      trailWidth: 1,
      attachment: props,
      step: function (state, circle, attachment) {
        // let { span, markerMap } = attachment,
        const progress = circle.value(),
          percent = Math.round(progress * 100);

        if (version === 2) {
          let current = +attachment.span.getAttribute('current'),
            marker = 3;
          // marker = attachment.markers.get(percent);
          // if (percent >= 17 && percent < 33)  {
          //   current = 3
          // }

          if (percent >= 33 && percent < 66) {
            marker = 2;
          }

          if (percent >= 66) {
            marker = 1;
          }

          console.log(marker);
          if (marker !== current) {
            attachment.span.setAttribute('current', marker);
            attachment.span.innerText = marker;
          }
        }

        circle.path.setAttribute('stroke-linecap', 'round');
        if (state.offset === 0) {
          container.classList.add('scale-out');
          if (!window.sooper_panel.query_params?.no_redirect) {
            const stack = Object.keys(self.tasks).map((k) => self.tasks[k]);
            validateTasks(stack);
            // setTimeout(() => {
            //   let params = new URLSearchParams(window.location.search);
            //   params.set('detour', true);
            //   return (window.location = `/full.php?${params}`);
            // }, 1500);
          }
        }
      },
    });
  }

  static initialize(props) {
    const { visit_id, user_id, funnel_id } = props;
    // document.body.setAttribute('is-detour', true);
    // const elem = document.getElementById('detour'),
    //   verticalContentElem = document
    //     .getElementById('content')
    //     .querySelector('div.vertical_content');

    // elem.innerHTML = updateTemplateAttributes(elem.innerHTML, attributes);
    // elem.removeAttribute('hidden');
    // verticalContentElem.append(elem);

    return new Detour({
      visit_id,
      user_id,
      funnel_id,
      profile: props.profile.values(),
    });
  }
}
